import { LineChartOutlined } from '@ant-design/icons';
import { Flex, Typography, theme } from 'antd';
import LastSynced from './LastSynced';

const { Text } = Typography;

interface LiveDownloadsEmptyStateProps {
  lastSyncedTimeUTC?: string;
}

const LiveDownloadsEmptyContent = ({ lastSyncedTimeUTC }: LiveDownloadsEmptyStateProps) => {
  const { token } = theme.useToken();

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap={token.marginXXS}
      style={{
        height: '100%',
        textAlign: 'center',
        paddingBlock: token.paddingXS,
        paddingInline: token.paddingXXS,
        maxWidth: 320,
        margin: '0 auto',
      }}
    >
      <LineChartOutlined
        aria-hidden
        style={{ fontSize: token.fontSizeXL, color: token.colorTextTertiary }}
      />
      <Text
        style={{
          fontSize: token.fontSizeSM,
          fontWeight: token.fontWeightStrong,
          color: token.colorTextSecondary,
        }}
      >
        No listens or views yet today
      </Text>
      <Text style={{ fontSize: 11, color: token.colorTextTertiary }}>
        Check back once listeners start tuning in
      </Text>
      <Text style={{ marginTop: 6 }}>
        <LastSynced lastSyncedTimeUTC={lastSyncedTimeUTC} />
      </Text>
    </Flex>
  );
};

export default LiveDownloadsEmptyContent;
